import axios from 'axios';

let prefix_1 = "/laboratory-operation"
let prefix_2 = "/content-sections"

const LaboratoryOperationApi = {
	//Laboratory Operation
	getLaboratoryOperationList(payload){
		return axios.get( prefix_1 + "/list", {params: payload})
	},
	archiveLaboratoryOperation(payload){
		return axios.delete( prefix_1 + "/delete", {params: payload})
	},
	createLaboratoryOperation(payload){
		return axios.post( prefix_1 + "/create", payload)
	},
	updateLaboratoryOperation(payload){
		return axios.post( prefix_1 + "/update", payload)
	},
	setLaboratoryOperationImage(payload, onUploadProgress = {} ){
		return axios.post(prefix_1 + "/upload", payload,{
			headers: { 'Content-Type': 'multipart/form-data'},
			onUploadProgress
		})
	},
	clearLaboratoryOperationImage(payload){
		return axios.delete( prefix_1 + "/delete-image", {params: payload})
	},

	//Laboratory Operation Item
	getContentSectionList(payload){
		return axios.get( prefix_2 + "/list", {params: payload})
	},
	getContentSectionByID(id){
		return axios.get( prefix_2 + "/" + id, {})
	},
	archiveContentSection(payload){
		return axios.delete( prefix_2 + "/delete", {params: payload})
	},
	createContentSection(payload){
		return axios.post( prefix_2 + "/create", payload)
	},
	updateContentSection(payload){
		return axios.post( prefix_2 + "/update", payload)
	},
	setContentSectionImage(payload, onUploadProgress = {} ){
		return axios.post(prefix_2 + "/upload", payload,{
			headers: { 'Content-Type': 'multipart/form-data'},
			onUploadProgress
		})
	},
	clearContentSectionImage(payload){
		return axios.delete( prefix_2 + "/delete-image", {params: payload})
	},
}

export default LaboratoryOperationApi;